import { createSelector } from 'reselect';
import { List } from 'immutable';
import { getTranslation } from 'src/i18n';

export const getCheckSheetState = (state) =>
  state.checkSheet;

export const getCheckSheetTasks = checkSheetType => createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    const tasks = checkSheets.getIn(['checkSheets', 'tasks', checkSheetType]) || List();
    return tasks.map(x => { return { order: x.get('order'), label: getTranslation(x.get('task')), key: x.get('task'), text_input_only: x.get('text_input_only') }; })
      .sort((a, b) => {a.order < b.order;} );
  }
);
export const getCheckSheetTasksLoading = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'tasks', 'loading'], true);
  }
);

export const getCheckSheetReport = id => createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'data', id, 'record']) || List();
  }
);

export const getSaveCheckSheetReportLoading = checkSheetType => createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'submit', checkSheetType, 'loading'], false);
  }
);

export const getCheckSheetReportLoading = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets',  'loading'], false);
  }
);

export const getCommissioningPdfLoading = checkSheetType => createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'pdf', checkSheetType, 'loading'], false);
  }
);

export const getCommissioningPdfLoadingByReportId = (reportId: string) => createSelector(
  [getCheckSheetState],
  (checkSheets) => checkSheets.getIn(['checkSheets', 'pdf', 'individual', reportId, 'loading'], false)
);

export const getSummaryCommissioningPdfLoading = createSelector(
  [getCheckSheetState],
  (checkSheets) => checkSheets.getIn(['checkSheets', 'pdf', 'summary', 'loading'], false)
);

export const getBulkCommissioningPdfLoading = createSelector(
  [getCheckSheetState],
  (checkSheets) => checkSheets.getIn(['checkSheets', 'pdf', 'bulk', 'loading'], false)
);

export const getCheckSheetReportIsOpen = checkSheetType => createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'submit', checkSheetType, 'open'], false);
  }
);

export const getCommissioningReports = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    const ids = checkSheets.getIn(['checkSheets', 'commissioning', 'ids'], List());
    return ids.map(id => checkSheets.getIn(['checkSheets', 'data', id, 'record'])).filter(Boolean);
  }
);

export const getCommissioningReportsLoading = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'commissioning', 'loading'], false);
  }
);

export const getCommissioningReportsTotal = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'commissioning', 'total'], 0);
  }
);

export const getCommissioningReportsTotalPages = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'commissioning', 'totalPages'], 0);
  }
);

export const getCommissioningLastLinkSuccess = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'commissioning', 'lastLinkSuccess'], 0);
  }
);

export const getCommissioningLastSaveSuccess = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['checkSheets', 'commissioning', 'lastSaveSuccess'], 0);
  }
);

export const getExportReportsLoading = createSelector(
  [getCheckSheetState],
  (checkSheets) => {
    return checkSheets.getIn(['exportReports', 'loading'], false);
  }
);
